import { MediaDisplay } from "@package/ui-wall-components";
import { useTriviaContext } from "../context-trivia";

type TriviaButtonVariant = "answer" | "action";

type TriviaButtonProps = {
  text: string;
  variant?: TriviaButtonVariant;
  media?: string;
  mediaAlt?: string;
  disabled?: boolean;
  selected?: boolean;
  onHandleMouse: (x: number, y: number) => void;
};

export function TriviaButton({
  text,
  variant = "action",
  media,
  mediaAlt,
  disabled = false,
  selected = false,
  onHandleMouse,
}: TriviaButtonProps) {
  const { config } = useTriviaContext();
  const isAnswer = variant === "answer";

  return (
    <button
      type="button"
      className={
        isAnswer
          ? "flex h-full w-full min-h-[10cqmin] flex-col items-center justify-center gap-[var(--trivia-space)] overflow-hidden font-bold"
          : "inline-flex items-center justify-center font-bold"
      }
      disabled={disabled}
      aria-label={text}
      style={{
        backgroundColor: config.theme.buttonBackground,
        color: config.theme.buttonText,
        borderRadius: "var(--trivia-radius)",
        fontSize: isAnswer
          ? "var(--trivia-text-answer)"
          : "var(--trivia-text-body)",
        padding: "var(--trivia-space)",
        opacity: disabled && !selected ? 0.5 : 1,
        boxShadow: selected
          ? `0 0 0 3px ${config.theme.accentColor} inset`
          : undefined,
        touchAction: "manipulation",
      }}
      onPointerDown={(e) => {
        if (!disabled) {
          onHandleMouse(e.screenX, e.screenY);
        }
      }}
    >
      {!!media && (
        <div className="min-h-0 w-full flex-1">
          <MediaDisplay
            id={media}
            alt={mediaAlt ?? text}
            forceFit
            classNameMedia="h-full w-full object-contain"
          />
        </div>
      )}
      <span className="hyphens-auto text-balance break-words">{text}</span>
    </button>
  );
}
